module.exports = __webpack_public_path__ + "static/media/addMore.0b5dfd02.svg";